import PropTypes from "prop-types";
import React from 'react';
import CustomModal from './CustomModal';

export default function ConfirmationModal(props) {
  return (
    <CustomModal
      onClose={() => { props.onClose(); }}
      width={'15%'}
      title="Confirmation"
      body={<p style={{ color: 'black' }}>{props.text}</p>}
      buttons={
        [
          {
            onClick: () => { props.onConfirm(); },
            text: 'Oui',
          },
          {
            onClick: () => { props.onClose(); },
            text: 'Non',
          },
        ]}
    />
  );
}

ConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  text: PropTypes.string
};
